<template>
  <div class="corpo-pagina">

    <div id="testsendmail" class="modal danger-igotu">
      <div class="modal-content">
        <h4><i class="material-icons red-text text-darken-4 icon-modal-size">error_outline</i>
            {{ translation('pagina.editor.email.titolo.modale.test.invio') }}</h4>
        <p>{{ translation('pagina.editor.email..modale.test.invio.001') }}</p>
        <p>{{ translation('pagina.editor.email..modale.test.invio.002') }}.</p>
        <p>{{ translation('pagina.editor.email..modale.test.invio.003') }} {{ authStore.getters.userInfo.email }}</p>
        <ul>
          <li v-for="(placeholder, index) in this.segnaposti" :key="index">
            <div class="input-field">
              <input id="subject" type="text" v-model="templateModel.testPlaceholter[placeholder]">
              <label for="name">{{ placeholder }}</label>
            </div>
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <a href="#!" @click="closeModal()" class="btn-large my-cancel-btn"><i
            class="material-icons left">add_circle_outline</i> {{ translation('btn.annulla') }}</a>
        <a href="#!" @click="invioTest($event)" class="btn-large"><i class="material-icons left">send</i> {{ translation('pagina.editor.email..modale.test.invio.004') }}</a>
      </div>
    </div>

     <div v-if="!this.updatable" class="row">

       <div class="col s12 m12 l4 xl4">

        <span>{{ translation('pagina.edit.email.invio.mail.avviso.no.modify') }}</span>

           <table id="main_table_notuptable" width="100%" align="center" border="0">
          <tbody>
            <tr class="tr-no-border">
              <td colspan="2">
                <table cellspacing="2" cellpadding="2" align="center" width="100%"
                  style="max-width: 600px;background-color: white" border="0">
                  <tbody>
                    <tr class="tr-no-border" align="center">
                      <td valign="top">

                        <div class="box-bottoni-up-img">
                          <div class="custom-file-upload-wrapper bottoni-upload">

                            <input type="file" ref="headerUpload" id="uploaHeader" class="hidden-file-input"
                              @change="onFileSelected" accept=".jpg,.jpeg,.png">
                          </div>

                          <img id="email_header" :src="shwoimg(templateModel.imgHeader.complete)" width="100%" alt="" class="">
                        </div>
                      </td>
                    </tr>
                    <tr class="tr-no-border">
                      <td id="email_body_anteprima" v-html="this.templateModel.bodyMail"></td>
                    </tr>
                    <tr class="tr-no-border">
                      <td height="50" style="height: 50px">

                        <div class="box-bottoni-up-img">
                          <div class="custom-file-upload-wrapper bottoni-upload">

                            <input type="file" ref="footerUpload" id="uploadFooter" class="hidden-file-input"
                              @change="onFileSelected" accept=".jpg,.jpeg,.png">
                          </div>

                          <img id="email_footer" :src="shwoimg(templateModel.imgFooter.complete)" width="100%" alt="" class="">
                        </div>

                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        </div>

     </div>
<div v-if="this.updatable" class="row">

  <!-- 📌 COLONNA 1 – Anteprima -->
  <div class="col s12 m12 l4 xl4">
    <SubMenuMail /><br />
    <h4>{{ translation('pagina.editor.email.antemprima') }}</h4><br />

    <div class="card white z-depth-1">
      <div class="card-content">

        <table id="main_table" width="100%">
          <tbody>

            <!-- HEADER -->
            <tr>
              <td class="tr-no-border">
                <div v-if="!templateModel.headerShow" class="box-no-image">No header</div>

                <div class="box-bottoni-up-img">
                  <div class="custom-file-upload-wrapper bottoni-upload">
                    <a v-red-tooltip="translation('btn.elimina.header.mail')" href="javascript:void(0)" class="btn-small img-button-delete"
                      @click="deleteImg(templateModel.imgHeader, 'header')">
                      <i class="material-icons">delete_forever</i>
                    </a>

                    <a v-red-tooltip="translation('btn.carica.header.mail')" href="javascript:void(0)" class="btn-small" @click="triggerFileHeader">
                      <i class="material-icons">cloud_upload</i>
                    </a>

                    <input type="file" ref="headerUpload" id="uploaHeader"
                      class="hidden-file-input" @change="onFileSelected" accept=".jpg,.jpeg,.png">
                  </div>

                  <img id="email_header" :src="shwoimg(templateModel.imgHeader.complete)" width="100%" />
                </div>
              </td>
            </tr>

            <!-- BODY -->
            <tr>
              <td class="tr-no-border">
                <div id="email_body"></div>
              </td>
            </tr>

            <!-- FOOTER -->
            <tr>
              <td class="tr-no-border">
                <div v-if="!templateModel.footerShow" class="box-no-image">No footer</div>

                <div class="box-bottoni-up-img">
                  <div class="custom-file-upload-wrapper bottoni-upload">
                    <a v-red-tooltip="translation('btn.elimina.footer.mail')" href="javascript:void(0)" class="btn-small img-button-delete"
                      @click="deleteImg(templateModel.imgFooter, 'footer')">
                      <i class="material-icons">delete_forever</i>
                    </a>

                    <a  v-red-tooltip="translation('btn.carica.footer.mail')"  href="javascript:void(0)" class="btn-small" @click="triggerFileFooter">
                      <i class="material-icons">cloud_upload</i>
                    </a>

                    <input type="file" ref="footerUpload" id="uploadFooter"
                      class="hidden-file-input" @change="onFileSelected" accept=".jpg,.jpeg,.png">
                  </div>

                  <img id="email_footer" :src="shwoimg(templateModel.imgFooter.complete)" width="100%" />
                </div>
              </td>
            </tr>

          </tbody>
        </table>

      </div>
    </div>
  </div>

  <!-- 📌 COLONNA 2 – Form Editor -->
  <div class="col s12 m12 l4 xl4">
    <div class="card white z-depth-1">
      <div class="card-content">

        <table id="main_table_form" width="100%">
          <tbody>

            <tr class="no-border-tr">
              <td>
                <div class="input-field">
                  <i class="material-icons prefix">contact_mail</i>
                  <input id="nameSender" type="text" v-model="templateModel.nameSender">
                  <label for="nameSender"
                    :class="{ 'active': templateModel.nameSender }">
                    {{ translation('pagina.editor.email.campo.nome.sender') }}
                  </label>
                  <span v-if="errorsender" class="error-message-style">
                    {{ errorsender }}
                  </span>
                </div>
              </td>
            </tr>

            <tr class="no-border-tr">
              <td>
                <div class="input-field">
                  <i class="material-icons prefix">subject</i>
                  <input id="subject" type="text" v-model="templateModel.subject">
                  <label for="subject"
                    :class="{ 'active': templateModel.subject }">
                    {{ translation('pagina.editor.email.campo.oggetto') }}
                  </label>
                  <span v-if="errorsubject" class="error-message-style">
                    {{ errorsubject }}
                  </span>
                </div>
              </td>
            </tr>

            <tr>
              <td><textarea ref="summernote"></textarea></td>
            </tr>

            <tr>
              <td>

                <h4 style="color:red">{{ translation('attention.modal.title') }}</h4>
                <p style="color:red" v-html="translation('msg.invio.mial.attectio')"></p>

              </td>
            </tr>

            <tr class="no-border-tr">
              <td>
                <a v-red-tooltip="translation('btn.salva.template.mail')"  href="javascript:void(0)" class="btn-small img-button-delete"
                  @click="salvaTemplate()">
                  <i class="material-icons">save</i>
                </a>

                <a v-red-tooltip="translation('btn.invia.template.mail.test')"  href="javascript:void(0)" class="btn-small img-button-delete"
                  @click="openModal()">
                  <i class="material-icons">send</i>
                </a>
              </td>
            </tr>

          </tbody>
        </table>

      </div>
    </div>
  </div>

  <!-- 📌 COLONNA 3 – Immagini Extra -->
  <div class="col s12 m12 l4 xl4">
    <div class="card white z-depth-1">
      <div class="card-content">

        <p class="info-img">{{ translation('pagina.editor.frase.upload.001') }}</p>
        <p class="info-img" v-html="translation('pagina.editor.frase.upload.002')"></p>

        <div class="custom-file-upload-wrapper" :class="{ 'disabled': isDisabled }">
          <a v-red-tooltip="translation('btn.carica.immagine.corpo.email.upload')" href="javascript:void(0)" class="btn-small" @click="triggerFileInput"
            :class="{ 'disabled': isDisabled }">
            <i class="material-icons">cloud_upload</i>
          </a>

          <input type="file" ref="fileInput" id="uploadimg" class="hidden-file-input"
            :disabled="isDisabled" @change="onFileSelected" accept=".jpg,.jpeg,.png">
        </div>

        <span v-if="errorMessage" class="error-message-style">{{ errorMessage }}</span>
        <span v-if="errorMessageLimit" class="error-message-style">{{ errorMessageLimit }}</span>

        <!-- LISTA IMMAGINI -->
        <ul v-if="listPreviwImg.length > 0" class="image-list">
          <li v-for="(img, index) in listPreviwImg" :key="index" class="image-wrapper">
            <table>
              <tr>
                <td style="width:80%;">
                  <img :src="img.complete" class="img-preview">
                </td>
                <td>
                  <a v-red-tooltip="translation('btn.carica.immagine.corpo.email')" href="javascript:void(0)" class="btn-small img-button-delete"
                    @click="insertImageIntoEditor(img.complete)">
                    <i class="material-icons">attach_file</i>
                  </a>

                  <a v-red-tooltip="translation('btn.rimuovi.immagine.corpo.email')"  href="javascript:void(0)" class="btn-small img-button-delete"
                    @click="deleteImg(img,'img')">
                    <i class="material-icons">delete_forever</i>
                  </a>
                </td>
              </tr>
            </table>
          </li>
        </ul>

      </div>
    </div>
  </div>

</div>

  </div>
</template>

<script>
import $ from 'jquery'
import 'summernote/dist/summernote-lite.js'
import 'summernote/dist/summernote-lite.css'
import eventSetting from '@/store/eventSettings.js'
import apiService from '@/services/apiService.js'
import { qrcode } from '@/models/qrcodeModel.js'
import loadingStore from '@/store/loading.js'
import translationStore from '@/store/translations'
import { userCallingModel } from '@/models/userCalling.js'
import authStore from '@/store/authStore.js'
import { templateModel } from '@/models/templateModel.js'
import toast from '@/services/toast.js'
import M from 'materialize-css'

export default {
  name: 'SummernoteEditor',
  components: {

  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // templateModel.imgFooter
      eventSetting: eventSetting,
      toast: toast,
      segnaposti: [],
      translationStore: translationStore,
      templateModel: templateModel,
      listPreviwImg: [],
      userCallingModel: userCallingModel,
      authStore: authStore,
      // headerImage: null,
      // footerImage: null,
      errorMessage: null,
      isDisabled: false,
      errorMessageLimit: null,
      summernoteInitialized: false,
      qrcode: { ...qrcode },
      event_labels: eventSetting.getters.structure,
      modal: null,
      errorsender: null,
      errorsubject: null,
      updatable: true
    }
  },
  computed: {
    translation () {
      return translationStore.getters.traduzione
    }
  },
  async mounted () {
    await this.templateModel.reset()

    const elems = document.getElementById('testsendmail')

    this.modal = M.Modal.init(elems, {
      onCloseEnd: () => {
      },
      onOpenEnd: () => {
        loadingStore.commit('setLoading', false)
      }
    })

    this.$nextTick(() => {
      if (this.$refs.summernote && !this.summernoteInitialized) {
        // const vm = this

        const CustomSelectButton = (context) => {
          const labels = context.options.customOptions.eventLabels || []
          let optionsHtml = '<option value="">' + this.translation('filed.select.one') + '</option>'

          optionsHtml += '<option class="custom-select-dropdown" value="##NAME##">' + this.translation('label.name.pax') + '</option>'
          optionsHtml += '<option class="custom-select-dropdown" value="##SURNAME##">' + this.translation('label.surname.pax') + '</option>'
          optionsHtml += '<option class="custom-select-dropdown" value="##EMAIL##">' + this.translation('label.email.pax') + '</option>'

          labels.forEach(label => {
            optionsHtml += `<option class="custom-select-dropdown" value="##${label.name.toUpperCase()}##">${label.name}</option>`
          })

          optionsHtml += '<option class="custom-select-dropdown" value="##QRCODE##">Qr Code</option>'

          const dropdownHtml = `
            <div class="note-btn-group btn-group custom-select-dropdown">
              <select class="custom-select note-btn">
                ${optionsHtml}
              </select>
            </div>
          `

          const $dropdown = $(dropdownHtml)

          $dropdown.find('.custom-select').on('change', async function () {
            const value = $(this).val()
            if (value) {
              if (value === '##QRCODE##') {
                const urlImg = process.env.VUE_APP_URL_DOMAIN + '/img/qrcode.png'

                // 1. Crea l'elemento immagine (<img>)
                const img = document.createElement('img')

                // 2. Imposta la sorgente (src)
                img.src = urlImg

                // 3. ✨ Imposta l'ID desiderato ✨
                img.id = 'qrcodeid' // <--- INSERIMENTO ID

                // Opzionale: aggiungi una classe
                img.classList.add('custom-inserted-image')

                // 4. Inserisci l'elemento nel Summernote editor
                context.invoke('editor.insertNode', img)
              } else {
                context.invoke('editor.insertText', value)
              }
            }
            $(this).val('')
          })
          return $dropdown[0]
        }

        $(this.$refs.summernote).summernote({
          placeholder: 'Scrivi qui...',
          disableDragAndDrop: true,
          defaultFontName: 'Work Sans',
          fontNames: ['Arial', 'Arial Black', 'Roboto', 'Roboto Slab', 'Work Sans', 'Comic Sans MS', 'Courier New', 'Times New Roman', 'Verdana'],
          toolbar: [
            ['style', ['style']],
            ['font', ['bold', 'italic', 'underline', 'clear']],
            ['fontname', ['fontname']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['height', ['height']],
            ['table', ['table']],
            ['insert', ['link', 'picture']],
            ['my-custom-options', ['customSelect']],
            ['view', ['fullscreen', 'codeview']]
          ],
          buttons: {
            customSelect: CustomSelectButton
          },
          customOptions: {
            eventLabels: this.event_labels
          },
          fontNamesIgnoreCheck: ['Arial', 'Arial Black', 'Roboto', 'Roboto Slab', 'Comic Sans MS', 'Courier New', 'Times New Roman', 'Verdana'],
          callbacks: {
            onInit: () => {
              $('.note-group-select-from-files').remove()
              this.summernoteInitialized = true
            },
            onChange: (contents) => {
              this.$emit('input', contents)
              document.getElementById('email_body').innerHTML = contents

              this.templateModel.bodyMail = contents
            },
            onDrop: function (e) {
              e.preventDefault()
              return false
            },
            // Disabilita l'inserimento tramite copia/incolla (solo per le immagini)
            onImageUpload: function (files) {
              return false
            }
          }
        })
        $(this.$refs.summernote).summernote('code', this.value)
        // document.getElementById('email_body_anteprima').innerHTML = this.value
      }
    })
    await this.listImages()
  },
  beforeDestroy () {
    if (this.$refs.summernote && this.summernoteInitialized) {
      $(this.$refs.summernote).summernote('destroy')
      this.summernoteInitialized = false
    }
  },
  watch: {
    value (newValue) {
      if (this.summernoteInitialized && newValue !== $(this.$refs.summernote).summernote('code')) {
        $(this.$refs.summernote).summernote('code', newValue)
      }
    }
  },
  methods: {

    shwoimg (img) {
      if (img) return 'https://igotu.it/ajax/proxy-image.php?url=' + img
    },

    validateForm () {
      if (templateModel.subject !== null && templateModel.subject.trim() !== '') {
        this.errorsubject = null
      } else {
        this.errorsubject = this.translation('filed.required.validation')
      }

      if (templateModel.nameSender !== null && templateModel.nameSender.trim() !== '') {
        this.errorsender = null
      } else {
        this.errorsender = this.translation('filed.required.validation')
      }
    },

    removeImageByFileName (fileName) {
      const $editor = $(this.$refs.summernote)
      const currentHTML = $editor.summernote('code')
      const $tempDiv = $('<div>').html(currentHTML)

      const imageSelector = `img[src*="${fileName}"]`

      const $imageToRemove = $tempDiv.find(imageSelector)

      if ($imageToRemove.length > 0) {
        $imageToRemove.remove()

        // 2. Aggiorna il contenuto di Summernote
        const newHTML = $tempDiv.html()
        $editor.summernote('code', newHTML)

        // console.log(`Immagine/i con nome file "${fileName}" rimossa/e da Summernote.`)
      }
    },

    extractPlaceholders (text) {
      // Espressione Regolare per trovare i segnaposto:
      // 1. /##/ - Corrisponde alla sequenza iniziale "##"
      // 2. (.*?) - Cattura qualsiasi carattere (in modo non avido, cioè si ferma al primo "##" successivo)
      // 3. /##/ - Corrisponde alla sequenza finale "##"
      // 4. /g - Flag globale: trova tutte le corrispondenze nella stringa
      const regex = /##(.*?)##/g

      // Usa matchAll per trovare tutte le corrispondenze
      const matches = [...text.matchAll(regex)]

      // Mappa i risultati per estrarre il testo completo del segnaposto
      // [0] è l'intera corrispondenza (es. '##NAME##')
      return matches.map(match => match[0])
    },

    scrollToError () {
      // 1. Controlla se il riferimento esiste
      const element = document.getElementById('main_table_form')

      if (element) {
        // 2. Utilizza $nextTick per assicurarti che il DOM sia aggiornato
        //    dopo che l'errore è stato reso visibile.
        this.$nextTick(() => {
          element.scrollIntoView({
            behavior: 'smooth', // Animazione fluida (opzionale)
            block: 'center' // Posiziona l'elemento al centro della viewport
          })
        })
      }
    },

    async invioTest (e) {
      e.preventDefault()

      this.closeModal()
      loadingStore.commit('setLoading', true)
      const token = await apiService.getClientCredentialsToken()

      if (!token) {
        loadingStore.commit('setLoading', false)
        this.$router.push('/error')
      } else {
        /* let table = ' <table id="main_table" width="100%" align="center" border="0"><tbody>'
        table += '<tr><td colspan="2"><table cellspacing="2" cellpadding="2" align="center" width="100%" style="max-width: 600px;background-color: white" border="0">'
        table += '<tbody><tr align="center"><td valign="top"><img src="' + this.headerImage + '" width="100%"></td></tr><tr><td>'
        table += this.summernoteContent
        table += '</td></tr><tr><td><img src="' + this.footerImage + '" width="100%" alt=""></td></tr></tbody></table></td></tr></tbody></table>' */

        const url = process.env.VUE_APP_URL_EVENTS + '/templatemail/test-mail'
        const eventId = this.eventSetting.getters.uidEvent
        await this.userCallingModel.costruttore(this.authStore.getters.userInfo, null, null, null, eventId, null)

        this.templateModel.user = this.userCallingModel

        // console.log(this.templateModel)

        // const payload = { bodyMail: table, user: this.userCallingModel, imgHeader: this.headerImage, imgFooter: this.footerImage }

        const jsonEvents = await apiService.sendRequestWithBearer('POST', url, token, this.templateModel)
        let msg = this.translation('pagina.editor.toast.save.template')
        msg += this.translation('pagina.mail.invio.test.ok')

        if (jsonEvents) {
          this.toast.createStampToast('thumb_up', msg, 'toast-green')
          this.templateModel.uid = jsonEvents.uid
        } else {
          loadingStore.commit('setLoading', false)
          this.$router.push('/error')
        }
      }
      loadingStore.commit('setLoading', false)
    },

    async openModal () {
      await this.validateForm()

      if (this.errorsubject == null && this.errorsender == null) {
        if (this.modal) {
          const text = this.templateModel.bodyMail
          this.segnaposti = this.extractPlaceholders(text)
          this.modal.open()
        }
      } else {
        this.scrollToError()
      }
    },

    closeModal () {
      if (this.modal) {
        this.modal.close()
      }
    },

    triggerFileFooter () {
      this.$refs.footerUpload.click()
    },

    triggerFileHeader () {
      this.$refs.headerUpload.click()
    },

    triggerFileInput () {
      if (!this.isDisabled) {
        this.$refs.fileInput.click()
      }
    },

    async salvaTemplate () {
      loadingStore.commit('setLoading', true)
      const token = await apiService.getClientCredentialsToken()

      if (!token) {
        loadingStore.commit('setLoading', false)
        this.$router.push('/error')
      } else {
        /* let table = ' <table id="main_table" width="100%" align="center" border="0"><tbody>'
        table += '<tr><td colspan="2"><table cellspacing="2" cellpadding="2" align="center" width="100%" style="max-width: 600px;background-color: white" border="0">'
        table += '<tbody><tr align="center"><td valign="top"><img src="' + this.headerImage + '" width="100%"></td></tr><tr><td>'
        table += this.summernoteContent
        table += '</td></tr><tr><td><img src="' + this.footerImage + '" width="100%" alt=""></td></tr></tbody></table></td></tr></tbody></table>' */

        const url = process.env.VUE_APP_URL_EVENTS + '/templatemail/save'
        const eventId = this.eventSetting.getters.uidEvent
        await this.userCallingModel.costruttore(this.authStore.getters.userInfo, null, null, null, eventId, null)

        this.templateModel.user = this.userCallingModel

        // console.log(this.templateModel)

        // const payload = { bodyMail: table, user: this.userCallingModel, imgHeader: this.headerImage, imgFooter: this.footerImage }

        const jsonEvents = await apiService.sendRequestWithBearer('POST', url, token, this.templateModel)
        const msg = this.translation('pagina.editor.toast.save.template')

        if (jsonEvents) {
          this.toast.createStampToast('thumb_up', msg, 'toast-green')
          this.templateModel.uid = jsonEvents.uid
        } else {
          loadingStore.commit('setLoading', false)
          this.$router.push('/error')
        }
      }
      loadingStore.commit('setLoading', false)
    },

    insertImageIntoEditor (imageUrl) {
      if (this.$refs.summernote) {
        // Inserisce l'immagine nell'editor di Summernote
        $(this.$refs.summernote).summernote('insertImage', imageUrl)
      }
    },

    async deleteImg (img, type) {
      loadingStore.commit('setLoading', true)

      this.errorMessageLimit = null

      try {
        if (type === 'footer') {
          this.templateModel.imgFooter = {}
          this.templateModel.footerShow = false
        } else if (type === 'header') {
          this.templateModel.imgHeader = {}
          this.templateModel.headerShow = false
        }

        // console.log(img)
        const path = img.path
        const formData = new FormData()
        formData.append('event_id', this.eventSetting.getters.uidEvent)
        formData.append('path', path)

        const url = process.env.VUE_APP_URL_EVENTS + '/images/delete-image'
        const token = await apiService.getClientCredentialsToken()
        const responseData = await apiService.sendRequestWithBearer(
          'DELETE',
          url,
          token,
          formData
        )

        if (responseData && responseData.message === 'ok') {
          await this.setImgeFooterHeader(responseData)
          this.removeImageByFileName(img.complete)
        } else {
          this.errorMessageLimit = responseData.message
        }
      } catch (error) {
        loadingStore.commit('setLoading', false)
        this.$router.push('/error')
      }

      loadingStore.commit('setLoading', false)
    },

    getFileNameFromUrl (url) {
      const parts = url.split('/')
      const fileName = parts[parts.length - 1]
      return fileName
    },
    async upgradeable (json) {
      // Se json o json.template NON esistono → updatable rimane TRUE
      if (json && json.template && typeof json.template.updatable !== 'undefined') {
        this.updatable = json.template.updatable
      } else {
        this.updatable = true
      }
    },

    async setImgeFooterHeader (json) {
      this.listPreviwImg = []

      if (json.template) {
        const t = json.template
        this.templateModel.reset()
        this.templateModel.bodyMail = t.bodyMail
        this.templateModel.nameSender = t.nameSender
        this.templateModel.subject = t.subject
        this.templateModel.uid = t.uid
        $(this.$refs.summernote).summernote('code', this.templateModel.bodyMail)
        document.getElementById('email_body').innerHTML = this.templateModel.bodyMail
      }

      if (this.templateModel.headerShow) {
        this.templateModel.imgHeader = { type: 0, path: this.getFileNameFromUrl(this.eventSetting.getters.header), complete: this.eventSetting.getters.header }
      } else {
        this.templateModel.imgHeader = {}
      }

      this.templateModel.imgFooter = {}

      if (json.images) {
        const j = json.images

        j.forEach(img => {
          if (img.type === 0) {
            this.templateModel.imgHeader = img
            this.templateModel.headerShow = true
          } else if (img.type === 1) {
            this.templateModel.imgFooter = img

            this.templateModel.footerShow = true
          } else {
            this.listPreviwImg.push(img)
          }
        })
      }

      if (this.listPreviwImg.length >= 2) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }

      // this.$forceUpdate()
    },

    async listImages () {
      loadingStore.commit('setLoading', true)
      this.templateModel.reset()
      const token = await apiService.getClientCredentialsToken()
      if (!token) {
        this.$router.push('/error')
      } else {
        const formData = new FormData()
        formData.append('event_id', this.eventSetting.getters.uidEvent)
        const url = process.env.VUE_APP_URL_EVENTS + '/templatemail/existe-template'
        const token = await apiService.getClientCredentialsToken()
        const responseData = await apiService.sendRequestWithBearer(
          'POST',
          url,
          token,
          formData
        )

        this.templateModel.imgHeader = this.eventSetting.getters.header
        // this.footerImage = this.eventSetting.getters.header

        if (responseData) {
          await this.setImgeFooterHeader(responseData)
          await this.upgradeable(responseData)
        }
      }
      loadingStore.commit('setLoading', false)
    },

    onFileSelected (event) {
      loadingStore.commit('setLoading', true)

      let url = process.env.VUE_APP_URL_EVENTS + '/images/upload'

      if (event.target.id === 'uploaHeader') {
        url += '/header'
      } else if (event.target.id === 'uploadFooter') {
        url += '/footer'
      }

      this.errorMessage = null // Resetta il messaggio di errore ad ogni nuova selezione
      this.selectedFile = null // Resetta il file selezionato
      this.previewUrl = null // Resetta l'anteprima

      const file = event.target.files[0]

      if (!file) {
        loadingStore.commit('setLoading', false)
        return
      }

      // 1. Validazione del tipo di file
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg']
      if (!allowedTypes.includes(file.type)) {
        this.errorMessage = this.translation('error.type.not.allowed')
        this.resetFileInput()
        return
      }

      // 2. Validazione della dimensione del file (max 5 MB)
      const maxSizeBytes = this.MAX_FILE_SIZE_MB * 1024 * 1024
      if (file.size > maxSizeBytes) {
        this.errorMessage = this.translation('img.size.large.error')
        this.resetFileInput()

        return
      }

      // 3. Validazione delle dimensioni dell'immagine (400x500)
      const reader = new FileReader()
      reader.onload = (e) => {
        loadingStore.commit('setLoading', true)
        const img = new Image()
        img.onload = () => {

          // this.selectedFile = file
          /* if (parseInt(img.width) !== parseInt(this.REQUIRED_WIDTH) || parseInt(img.height) !== parseInt(this.REQUIRED_HEIGHT)) {
            this.errorMessage = this.translation.getters.traduzione('img.width.height.error')

            this.resetFileInput()
          } else {
            // Tutte le validazioni passate: imposta il file selezionato e l'anteprima
            // this.selectedFile = file
            // this.previewUrl = URL.createObjectURL(file)
          } */
        }

        img.onerror = () => {
          this.errorMessage = this.translation('img.read.error')
          this.resetFileInput()
        }
        img.src = e.target.result
      }
      reader.readAsDataURL(file) // Legge il file come URL di dati (Base64)
      this.sendForm(file, url)
      loadingStore.commit('setLoading', false)
    },

    resetFileInput () {
      // Resetta l'input file per permettere all'utente di selezionare lo stesso file dopo un errore
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
      loadingStore.commit('setLoading', false)
    },

    async sendForm (file, url) {
      loadingStore.commit('setLoading', true)
      // Blocca l'invio se non c'è un file selezionato o se ci sono errori
      if (this.errorMessage) {
        loadingStore.commit('setLoading', false)
        return
      }

      const formData = new FormData()
      // this.eventFiledModel.event_id = this.eventSetting.getters.uidEvent

      formData.append('img', file)
      formData.append('event_id', this.eventSetting.getters.uidEvent)

      try {
        const token = await apiService.getClientCredentialsToken()
        const responseData = await apiService.sendRequestWithBearer(
          'POST',
          url,
          token,
          formData
        )

        if (responseData && responseData.message === 'ok') {
          await this.setImgeFooterHeader(responseData)
        } else {
          this.errorMessageLimit = responseData.message
        }

        loadingStore.commit('setLoading', false)
      } catch (error) {
        // console.error('Errore durante l\'invio del form:', error)
        loadingStore.commit('setLoading', false)
        this.errorMessageLimit = null
        this.$router.push('/error')
      }
      loadingStore.commit('setLoading', false)
    }
  }
}
</script>

<style scoped>
/* Stili specifici per il componente Editor Template Email */
.note-editor.note-frame {
  /* Nasconde l'intera area di drop che appare in overlay */
  border: none !important;
}

/* Questa è la regola chiave per nascondere il messaggio */
.note-editor.note-frame.note-dragover .note-dropzone {
  /* Rimuove l'overlay completo e il testo */
  display: none !important;
  visibility: hidden !important;
}

.dragover {
  display: none !important;
  visibility: hidden !important;
}

.footer-hide {
  display: none;
}

.email_body {
  font-family: 'Roboto';
}

.custom-select {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4px 8px;
  background-color: #fff;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.custom-select-dropdown {
  text-align: left !important;
}

.note-btn-group {
  text-align: left;
}

.img-preview {
  width: 100% !important;
}

.img-button-delete {
  text-align: center !important;
}

.custom-file-input-wrapper.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.custom-file-input-wrapper.disabled .custom-file-button {
  pointer-events: none;
  /* Impedisce gli eventi del mouse */
}

.hidden-file-input {
  display: none !important;
}

/* Opzionale: per fare in modo che il bottone e l'input siano vicini o contenuti */
.custom-file-upload-wrapper {
  display: inline-block;
  /* o flex/block a seconda del layout desiderato */
}

.bottoni-upload {
  position: absolute;
  right: 0;
  margin-top: 15px;
  margin-right: 15px;
}

.box-bottoni-up-img {
  position: relative !important;
  width: 100% !important;
}

.tr-no-border {
  border: 0px !important;
}

.box-no-image {
  display: table-cell;
  width: 100%;
  vertical-align: middle;
  text-align: center;

}

tr.no-border-tr {
  border: 0px !important;
}

.info-img {
  font-size: 12px;
}

.icon-margin-example{
margin-left: 5px;
    margin-right: 5px;
    font-weight: bold;
}

</style>
